/* unplugin-vue-components disabled */import { render } from "./LoadingDots.vue?vue&type=template&id=63e8f5e8"
import script from "./LoadingDots.vue?vue&type=script&lang=js"
export * from "./LoadingDots.vue?vue&type=script&lang=js"

import "./LoadingDots.vue?vue&type=style&index=0&id=63e8f5e8&lang=scss"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__